/* eslint-disable no-underscore-dangle */
const ACTION_ENUM = {
  CONFIRM: 'confirm',
  CANCEL: 'cancel',
}

function setStyleByLanguage() {
  const currentLanguage = window.$i18next.language
  console.log('currentLanguage', currentLanguage)

  // 언어별 direction css 적용 (아랍어는 rtl)
  const dir = window.$i18next.dir(currentLanguage)
  document.body.style.direction = dir
}

export default class GlobalModal {
  constructor() {
    this.ACTION = ACTION_ENUM
    this.$t = window.$t
    this.modalEl = document.querySelector('#global-modal')
  }

  /**
   * @param {string} type confirm/warning
   */
  _show(type = 'confirm') {
    this.modalEl.classList.add(type)
    this.modalEl.style.display = 'flex'
  }

  _hide() {
    this.modalEl.style.display = 'none'
  }

  setModalInfo({
    title, message, confirmText, cancelText, callback,
  } = {}) {
    const titleEl = document.querySelector('#modal-title')
    const contentEl = document.querySelector('#modal-content')
    const confirmBtnEl = document.querySelector('#btn-confirm')
    const cancelBtnEl = document.querySelector('#btn-cancel')

    titleEl.innerText = title
    titleEl.style.display = title ? 'block' : 'none'
    contentEl.innerText = message
    confirmBtnEl.innerText = confirmText || this.$t('confirm', { ns: 'common' })
    cancelBtnEl.innerText = cancelText
    cancelBtnEl.style.display = cancelText ? 'block' : 'none'

    confirmBtnEl.addEventListener('click', () => this.btnClickHandler(callback, ACTION_ENUM.CONFIRM))
    cancelBtnEl.addEventListener('click', () => this.btnClickHandler(callback, ACTION_ENUM.CANCEL))

    setStyleByLanguage()
  }

  btnClickHandler(callback, action) {
    this._hide()
    if (typeof callback === 'function') {
      callback(action)
    }
  }

  confirm({
    title, message, confirmText, cancelText = this.$t('cancel', { ns: 'common' }),
  } = {}) {
    return new Promise((resolve) => {
      this.setModalInfo({
        title, message, confirmText, cancelText, callback: resolve,
      })
      this._show('confirm')
    })
  }

  warning({
    title, message, confirmText,
  } = {}) {
    return new Promise((resolve) => {
      this.setModalInfo({
        title, message, confirmText, callback: resolve,
      })
      this._show('warning')
    })
  }
}

// window.$globalModal = new GlobalModal()
